import script from "./TemplateForm.vue?vue&type=script&setup=true&lang=js"
export * from "./TemplateForm.vue?vue&type=script&setup=true&lang=js"

import "./TemplateForm.vue?vue&type=style&index=0&id=43a76ce8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43a76ce8"]])

export default __exports__